import Vue from 'vue';
import Router from 'vue-router';
import i18n from '@/translations';

// Views
import Login from '@/views/Login';
import SecurePassword from '@/views/SecurePassword';
import ForgotPassword from '@/views/ForgotPassword';
import ResetPassword from '@/views/ResetPassword';

import MiddlewareManager from './utils/MiddlewareManager';


Vue.use(Router);

const routes = [];

Object.keys(i18n.messages).forEach((locale) => {
	routes.push({
		path: i18n.messages[locale].routes.home,
		name: `home-${locale}`,
		component: Login,
	});

	routes.push({
		path: i18n.messages[locale].routes.home,
		name: `login-${locale}`,
		component: Login,
	});

	routes.push({
		path: i18n.messages[locale].routes['forgot-password'],
		name: `forgot-password-${locale}`,
		component: ForgotPassword,
	});

	routes.push({
		path: i18n.messages[locale].routes['secure-password'],
		name: `secure-password-${locale}`,
		component: SecurePassword,
	});

	routes.push({
		path: i18n.messages[locale].routes['reset-password'],
		name: `reset-password-${locale}`,
		component: ResetPassword,
	});

	routes.push({
		path: i18n.messages[locale].routes.logout,
		name: `logout-${locale}`,
	});
});

routes.push({
	path: '*',
	name: 'default',
	redirect: {
		name: 'home-fr',
	},
});

routes.push({
	path: '/password/reset-code',
});

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});
MiddlewareManager.use(router);

export default router;
